<template>
  <div class="voice-bar-wrapper progress-css relative inline-block">
    <span class="progress-font-css absolute">
      {{ data && data.type === 'detail' ? '详细语音讲解' : '简单语音讲解' }}
    </span>
    <span
      class="inline-block progress-bar cursor-pointer absolute"
      @click="settingProgress"
    >
    </span>
    <div
      class="progress-bar-big cursor-pointer absolute"
      :style="`width: ${progressBarWidth}`"
      @click="settingProgress"
    >
      <i class="absolute pin-r"></i>
    </div>
    <div class="infomation">
      <i
        v-show="playing"
        class="iconfont icon-stop1 cursor-pointer inline-block"
        @click="togglePlaying"
      ></i>
      <i
        v-show="!playing"
        class="iconfont icon-play1 cursor-pointer inline-block"
        @click="togglePlaying"
      ></i>

      <span class="pull-right mr-1 float-right">{{
        this.formatSecond(this.seek, true)
      }}</span>
    </div>
  </div>
</template>

<script>
import VueHowler from 'vue-howler'

export default {
  name: 'manage-player',
  mixins: [VueHowler],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: null
    },
    setting: {
      type: Array,
      default: null
    }
  },
  computed: {
    progressBarWidth() {
      if (!this.value) {
        return '140px'
      }
      return this.progress * 140 + 'px'
    }
  },
  watch: {
    setting() {
      if (this.setting && this.setting.length > 0) {
        this.setting.forEach(item => {
          this[item.name] = item.value
        })
      }
    }
  },
  mounted() {},
  methods: {
    formatSecond: function(sec, forceZoreMinute) {
      if (!sec || isNaN(sec)) {
        return '00:00'
      }
      if (sec > 59 || forceZoreMinute) {
        return (
          Math.floor(sec / 60)
            .toString()
            .padStart(2, '0') +
          ':' +
          Math.floor(sec % 60)
            .toString()
            .padStart(2, '0') +
          ''
        )
      } else {
        return (
          Math.floor(sec % 60)
            .toString()
            .padStart(2, '0') + ''
        )
      }
    },
    togglePlaying() {
      let obj = this.$parent.$refs
      for (let key in obj) {
        if (this.$parent.$refs[key] && this.$parent.$refs[key][0]) {
          this.$parent.$refs[key][0].pause()
        }
      }
      this.togglePlayback()
    },
    settingProgress(e) {
      this.setProgress(e.layerX / 140)
      this.play()
    }
  }
}
</script>

<style lang="scss" scoped>
.voice-bar-wrapper {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  .infomation {
    font-size: 12px;
    width: 100%;
    text-align: left;
  }
  .progress-font-css {
    font-size: 8px;
    line-height: 1;
    top: 16%;
    left: 36px;
  }
  .iconfont {
    margin-top: 8px;
    font-size: 1rem;
    padding-left: 7px;
    padding-right: 6px;
    border-right: 1px solid #fff;
    line-height: 19px;
  }

  .progress-css {
    height: 14px;
    padding: 0 50px;
  }
  .progress-bar,
  .progress-bar-big {
    top: 70%;
    left: 36px;
    width: 140px;
    height: 2px;
    background-color: #fff;
  }
  .progress-bar-big {
    height: 4px;
    width: 0;
    margin-top: -1px;
    > i {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #fff;
      top: -2.3px;
      right: -7.5px;
    }
  }
  .pull-right {
    margin-top: 18px;
    line-height: 1;
  }
}
</style>
